<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Article</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/articles" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
          <form @submit.prevent="updateArticle" v-if="article">
            <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="article.articleHead"
                              label="Title"
                              placeholder="Enter Article Title"
                              v-validate="rules.articleHead"
                              data-vv-name="Article Title"
                              cus-name="Article Title"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-5">
                    <fg-input type="text"
                              v-model="article.imageUrl"
                              label="Image URL"
                              placeholder="Enter Image URL"
                              data-vv-name="imageUrl"
                              cus-name="imageUrl"
                              v-validate="rules.imageUrl"
                              :has-errors="errors"
                              :is-fields="fields"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-5">
                    <label>Published Date</label>
                    <datetime v-model="publishDate"
                              required
                              input-class="form-control"
                              label="Published Date"
                              placeholder="Select Date"
                              type="date"
                              input-format="DD-MM-YYYY"
                              auto-continue>
                    </datetime>
                    <!--<fg-input type="text"-->
                    <!--v-model="article.datePublish"-->
                    <!--label="Published Date"-->
                    <!--placeholder="Enter Date"-->
                    <!--data-vv-name="datePublish"-->
                    <!--cus-name="datePublish"-->
                    <!--v-validate="rules.datePublish"-->
                    <!--:has-errors="errors"-->
                    <!--:is-fields="fields"-->
                    <!--&gt;-->
                    <!--</fg-input>-->
                  </div>
                  <div class="col-md-5">
                    <fg-input type="text"
                              v-model="article.authorUrl"
                              label="Author URL (Optional)"
                              placeholder="Enter Author URL (Optional)"
                              data-vv-name="authorUrl"
                              cus-name="authorUrl"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-5">

                    <fg-input type="text"
                              v-model="article.authorName"
                              label="Author Name"
                              placeholder="Enter Author Name"
                              data-vv-name="authorName"
                              cus-name="authorName"
                              v-validate="rules.authorName"
                              :has-errors="errors"
                              :is-fields="fields"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph1"
                                  label="Paragraph 1"
                                  placeholder="Enter Paraghraph 1"
                                  v-validate="rules.paragraph1"
                                  data-vv-name="paragraph1"
                                  cus-name="paragraph1"
                                  :has-errors="errors"
                                  :is-fields="fields">
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph2"
                                  label="Paragraph 2"
                                  placeholder="Enter Paragraph 2"
                                  v-validate="rules.paragraph2"
                                  data-vv-name="paragraph2"
                                  cus-name="paragraph2"
                                  :has-errors="errors"
                                  :is-fields="fields">
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph3"
                                  label="Paragraph 3"
                                  placeholder="Enter Paraghraph 3"
                                  v-validate="rules.paragraph3"
                                  data-vv-name="paragraph3"
                                  cus-name="paragraph3"
                                  :has-errors="errors"
                                  :is-fields="fields">
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph4"
                                  label="Paragraph 4"
                                  placeholder="Enter Paraghraph 4"
                                  data-vv-name="paragraph4"
                                  cus-name="paragraph4"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph5"
                                  label="Paragraph 5"
                                  placeholder="Enter Paraghraph 5"
                                  data-vv-name="paragraph5"
                                  cus-name="paragraph5"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph6"
                                  label="Paragraph 6"
                                  placeholder="Enter Paraghraph 6"
                                  data-vv-name="paragraph6"
                                  cus-name="paragraph6"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph7"
                                  label="Paragraph 7"
                                  placeholder="Enter Paraghraph 7"
                                  data-vv-name="paragraph7"
                                  cus-name="paragraph7"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph8"
                                  label="Paragraph 8"
                                  placeholder="Enter Paraghraph 8"
                                  data-vv-name="paragraph8"
                                  cus-name="paragraph8"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph9"
                                  label="Paragraph 9"
                                  placeholder="Enter Paraghraph 9"
                                  data-vv-name="paragraph9"
                                  cus-name="paragraph9"
                    >
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="article.paragraph10"
                                  label="Paragraph 10"
                                  placeholder="Enter Paraghraph 10"
                                  data-vv-name="paragraph10"
                                  cus-name="paragraph10"
                    >
                    </fg-text-area>
                  </div>
                </div>
                <div class="col-3" v-if="status.length">
                <fg-select
                v-model="article.active"
                label="isActive"
                v-validate="rules.active"
                data-vv-name="active"
                cus-name="active"
                :has-errors="errors"
                :is-fields="fields"
                :list="status"
                selectedKey="id"
                >
                </fg-select>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Update Article
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditArticle',
        created (){
        this.$store.dispatch('GETSELECTEDARTICLE', this.$route.params.id).then(() =>{
            this.article = this.selectedArticle;
            this.publishDate = new Date(this.article.datePublish).toISOString();
        })
    },
    data () {
        let dateTime = new Date();
        return {
            publishDate: dateTime.toISOString(),
            article: this.selectedArticle || {},
          rules: {
            articleHead: {required : true},
            authorName: {required: true},
            imageUrl: {required : true},
            paragraph1: {required : true},
            paragraph2: {required : true},
            paragraph3: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:true, name:'Active'}, {id:false, name:'Inactive'}],
        }
    },
    methods: {
        updateArticle () {
          this.$validator.validateAll().then((result) => {
            if(result){
              this.article.datePublish =  moment(this.publishDate).format('MM/DD/YYYY');
              let updateAtricle = () =>{
                this.$store.dispatch('UPDATE_ARTICLE', this.article)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Article is successfully updated', 'success', ()=>this.$router.push('/admin/articles'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_Article API error : ", err);
                  })
              };
              updateAtricle();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'articles', `getArticle${11}`, 'selectedArticle']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Articles/EditArticle.vue